
import {Options, Vue} from 'vue-class-component';

@Options({
    components: {
    },
    created() {
        console.log(window.location.href);

        // this.$route.query.courseId值为1代表级别1，2代表级别2
        this.init(this.$route.query.userId);
    }
})
export default class CourseIntroduce extends Vue {
    courseInfo:objMap = {};

    init(uid:string) {
        // 此处的userId是家长中心的短id，即学号，
        this.$http.get(`${this.$Api.courseIntroduction}?uid=${uid}`).then((res:any) => {
            if (res.code === '0') {
                this.getContent(res.data.courseIntroductionUrl);
            }
            else {
                this.$toast('获取课程介绍失败');
            }
        });
    }

    getContent(url:string) {
        this.$http.get(url).then((res:any) => {
            res = Object.prototype.toString.call(res) === '[object String]' ? JSON.parse(res) : res;
            if (res.code === '0') {
                const arr = res.data.levelList;
                if (arr && arr.length) {
                    const self = this;
                    arr.forEach((item:any) => {
                        item.weekLength = item.weekList.length;
                        (item.courseLevel === Number(self.$route.query.courseId))
                            && (self.courseInfo = item);
                    });
                }
            }
            else {
                this.$toast('获取课程介绍失败');
            }
        });
    }
}
